import { useMemo } from "react";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useAuditoriasAuditoriasViewModel } from "../../viewModels/auditorias_auditorias_view_model";
import { GenerateAuditoriaAuditoriasColumns } from "./columns/auditoria_auditorias";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { AuditoriasLista } from "../../../domain/models/auditorias_lista";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";
import { CopiaAuditoriaModal } from "./components/copia_auditoria_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

export const Auditorias = () => {

  const viewModel = useAuditoriasAuditoriasViewModel();
  const AuditoriaAuditoriasListalColumns = useMemo(() => {
    return GenerateAuditoriaAuditoriasColumns({
      onActionEditar: viewModel.handleCadastroOpenState,
      onActionDeletar: viewModel.handleDeleteAuditoriaModalOpenState,
      onActionCopiar: viewModel.handleAuditoriaCopiaOpenState,
      onActionExportar: viewModel.handleAuditoriaExportar,
    });
  }, [viewModel.handleAuditoriaCopiaOpenState, viewModel.handleAuditoriaExportar, viewModel.handleCadastroOpenState, viewModel.handleDeleteAuditoriaModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroOpenState(null)}>
                  Nova Auditoria
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Auditoria
            </Link>
            <Typography className="text-primary-green">
              Auditorias
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Auditorias Lista</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
            handleStatus={viewModel.handleStatusChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            tipoPesquisa={viewModel.filters.tipoPesquisa}
            status={viewModel.filters.status}

          />
          <StyledDataGrid
            tableName="auditorias_lista"
            disableColumnMenu={false}
            getRowId={(row: AuditoriasLista) => row.IdAuditoria}
            columns={AuditoriaAuditoriasListalColumns}
            loading={viewModel.loading}
            rows={viewModel.auditoriasLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ["IdAuditoria"],
            }}
            autoHeight={true}
            textSize="medio"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>



      {/* Relatorio */}
      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.AuditoriasDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteAuditoriaModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaAuditoria} />

      {/* ModalCopia */}
      <CopiaAuditoriaModal
        open={viewModel.openCopiaModal}
        saving={viewModel.saving}
        selectedAuditoriaCopia={viewModel.selectedAuditoria}
        titulo={"Copia Auditoria"}
        onSubmit={viewModel.handleSubmitCopiaAuditoria}
        onClose={() => viewModel.handleAuditoriaCopiaOpenState(null, false)}
      />
    </>
  )
};
